import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import GLightbox from 'glightbox';

document.addEventListener('DOMContentLoaded', () => {
  // Gallery Slider
  const gallerySlider = document.querySelector('.gallery-slider');
  if (gallerySlider) {
    const swiper = new Swiper(gallerySlider, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: '.gallery-slider__nav--next',
        prevEl: '.gallery-slider__nav--prev',
      },
      pagination: {
        el: '.gallery-slider__dots',
        clickable: true,
      },
    });

    // Initialize GLightbox
    const lightbox = GLightbox({
      selector: '.glightbox',
      touchNavigation: true,
      loop: true,
      autoplayVideos: true,
    });
  }

  // Upsells Slider
  const upsellsSlider = document.querySelector('.upsells-slider');
  if (upsellsSlider) {
    new Swiper(upsellsSlider, {
      modules: [Navigation],
      slidesPerView: 1.2,
      spaceBetween: 16,
      navigation: {
        nextEl: '.upsells-slider__nav--next',
        prevEl: '.upsells-slider__nav--prev',
      },
      breakpoints: {
        600: {
          slidesPerView: 1.6,
        },
        800: {
          slidesPerView: 2.2,
        },
        980: {
          slidesPerView: 3.2,
        },
        1280: {
          slidesPerView: 4,
        },
      },
    });
  }
});
